import { render, staticRenderFns } from "./ListAdvertisers.vue?vue&type=template&id=08c86a3e&"
import script from "./ListAdvertisers.vue?vue&type=script&lang=js&"
export * from "./ListAdvertisers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports